export default __webpack_public_path__ + "static/media/icon_artifact-size_medium.fe572290.svg";